<template>
  <v-card>
    <v-card-title>
      <span :class="['headline indigo--text text--darken-2 font-weight-medium']">{{header1}}</span>
      <span :class="['headline indigo--text text--darken-2 ml-2']">client</span>
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text style="height: 420px;">
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field label="First Name(s)" v-model="item.client.firstName"></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field label="Last Name" v-model="item.client.lastName"></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field label="Address Line 1" v-model="item.client.addressLine1"></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field label="Address Line 2" v-model="item.client.addressLine2"></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field label="City" v-model="item.client.city"></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field label="Postcode" v-model="item.client.postcode"></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field label="County" v-model="item.client.county"></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field label="Home phone" v-model="item.client.telHome" prepend-icon="mdi-phone"></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            label="Mobile"
            v-model="item.client.telMobile"
            prepend-icon="mdi-cellphone-iphone"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            :items="countries"
            label="Country"
            prepend-icon="mdi-flag"
            v-model="item.client.country"
          ></v-select>
        </v-col>

        <!-- <v-col cols="12" md="6">
          <v-text-field label="First Name(s)" v-model="item.client.firstName"></v-text-field>
          <v-text-field label="Last Name" v-model="item.client.lastName"></v-text-field>
          <v-text-field label="Address Line 1" v-model="item.client.addressLine1"></v-text-field>
          <v-text-field label="Address Line 2" v-model="item.client.addressLine2"></v-text-field>
          <v-text-field label="City" v-model="item.client.city"></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field label="Postcode" v-model="item.client.postcode"></v-text-field>
          <v-text-field label="County" v-model="item.client.county"></v-text-field>
          <v-text-field label="Home phone" v-model="item.client.telHome" prepend-icon="mdi-phone"></v-text-field>
          <v-text-field
            label="Mobile"
            v-model="item.client.telMobile"
            prepend-icon="mdi-cellphone-iphone"
          ></v-text-field>
          <v-select
            :items="countries"
            label="Country"
            prepend-icon="mdi-flag"
            v-model="item.client.country"
          ></v-select>
        </v-col>-->
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn color="red darken-1" text @click="showDeleteDialog" v-if="!this.item.inNewMode">Delete</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="item.updateClient(item.client)">Update</v-btn>
      <v-btn color="green darken-1" text @click="item.closeDialog()">Close</v-btn>
    </v-card-actions>

    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogDeleteClient" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>{{ dialogTitle }}</v-card-title>
            <v-card-text class="mt-4 subtitle-2">{{ dialogMain }}</v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="!canDelete" color="error" text @click="removeClient">Yes, remove</v-btn>
              <v-btn color="normal" text @click="dialogDeleteClient = false">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-card>
</template>

<script>
export default {
  props: {
    item: Object
  },
  computed: {
    canDelete() {
      return this.item.canDelete;
    },
    header1() {
      if (this.item.inNewMode) return "New";
      return "Edit";
    },
    dialogTitle() {
      if (this.canDelete) return "Delete client";
      else return "Can't remove this client!";
    },
    dialogMain() {
      if (this.canDelete)
        return "You are about to remove this client, are you sure?";
      else
        return "You can't remove this client since it is currently linked to one or more projects!";
    }
  },
  name: "DialogClient",
  methods: {
    removeClient() {
      this.dialogDeleteClient = false;
      if (this.canDelete) this.item.deleteClient(this.item.client);
    },
    showDeleteDialog() {
      this.dialogDeleteClient = true;
    }
  },
  data() {
    return {
      dialogDeleteClient: false,
      radio: "new",
      components: [
        "Autocompletes",
        "Comboboxes",
        "Forms",
        "Inputs",
        "Overflow Buttons",
        "Selects",
        "Selection Controls",
        "Sliders",
        "Textareas",
        "Text Fields"
      ],
      counties: [
        "Aberdeenshire",
        "Angus",
        "Antrim",
        "Argyll",
        "Armagh",
        "Ayrshire",
        "Banffshire",
        "Berkshire",
        "Berwickshire",
        "Bristol",
        "Buckinghamshire",
        "Bute",
        "Caithness",
        "Cambridgeshire",
        "Cheshire",
        "City of London",
        "Clackmannanshire",
        "Clwyd",
        "Cornwall",
        "Cumbria",
        "Derbyshire",
        "Devon",
        "Dorset",
        "Down",
        "Dumfriesshire",
        "Dunbartonshire",
        "Durham",
        "Dyfed",
        "East Lothian",
        "East Riding of Yorkshire",
        "East Sussex",
        "Essex",
        "Fermanagh",
        "Fife",
        "Gloucestershire",
        "Greater London",
        "Greater Manchester",
        "Gwent",
        "Gwynedd",
        "Hampshire",
        "Herefordshire",
        "Hertfordshire",
        "Inverness-shire",
        "Isle of Wight",
        "Kent",
        "Kincardineshire",
        "Kinross-shire",
        "Kirkcudbrightshire",
        "Lanarkshire",
        "Lancashire",
        "Leicestershire",
        "Lincolnshire",
        "Londonderry",
        "Merseyside",
        "Mid Glamorgan",
        "Midlothian",
        "Moray",
        "Nairnshire",
        "Norfolk",
        "North Yorkshire",
        "Northamptonshire",
        "Northumberland",
        "Nottinghamshire",
        "Orkney",
        "Oxfordshire",
        "Peeblesshire",
        "Perthshire",
        "Powys",
        "Renfrewshire",
        "Ross and Cromarty",
        "Roxburghshire",
        "Rutland",
        "Selkirkshire",
        "Shetland",
        "Shropshire",
        "Somerset",
        "South Glamorgan",
        "South Yorkshire",
        "Staffordshire",
        "Stirlingshire",
        "Suffolk",
        "Surrey",
        "Sutherland",
        "Tyne and Wear",
        "Tyrone",
        "Warwickshire",
        "West Glamorgan",
        "West Lothian",
        "West Midlands",
        "West Sussex",
        "West Yorkshire",
        "Wigtownshire",
        "Wiltshire",
        "Worcestershire"
      ],
      countries: [
        "United Kingdon",
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and/or Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cape Verde",
        "Cayman Islands",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands",
        "Colombia",
        "Comoros",
        "Congo",
        "Cook Islands",
        "Costa Rica",
        "Croatia (Hrvatska)",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "East Timor",
        "Ecudaor",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Ethiopia",
        "Falkland Islands (Malvinas)",
        "Faroe Islands",
        "Fiji",
        "Finland",
        "France",
        "France, Metropolitan",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard and Mc Donald Islands",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran (Islamic Republic of)",
        "Iraq",
        "Ireland",
        "Israel",
        "Italy",
        "Ivory Coast",
        "Jamaica",
        "Japan",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea, Democratic People's Republic of",
        "Korea, Republic of",
        "Kosovo",
        "Kuwait",
        "Kyrgyzstan",
        "Lao People's Democratic Republic",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libyan Arab Jamahiriya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macau",
        "Macedonia",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia, Federated States of",
        "Moldova, Republic of",
        "Monaco",
        "Mongolia",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "Netherlands Antilles",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Niue",
        "Norfork Island",
        "Northern Mariana Islands",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Pitcairn",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Reunion",
        "Romania",
        "Russian Federation",
        "Rwanda",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia South Sandwich Islands",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "St. Helena",
        "St. Pierre and Miquelon",
        "Sudan",
        "Suriname",
        "Svalbarn and Jan Mayen Islands",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syrian Arab Republic",
        "Taiwan",
        "Tajikistan",
        "Tanzania, United Republic of",
        "Thailand",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United States",
        "United States minor outlying islands",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Vatican City State",
        "Venezuela",
        "Vietnam",
        "Virigan Islands (British)",
        "Virgin Islands (U.S.)",
        "Wallis and Futuna Islands",
        "Western Sahara",
        "Yemen",
        "Yugoslavia",
        "Zaire",
        "Zambia",
        "Zimbabwe"
      ]
    };
  }
};
</script>

<style scoped>
</style>
